import $ from 'jquery';
import 'bootstrap/js/dist/carousel';
import ImageLoader from './imageLoader';

class Carousel {
	constructor() {
		this.events();
	}

	events() {
	    const that = this,
	    	  $carousel = $('.carousel'),
	    	  $carouselItems = $('.carousel-item'),
	    	  $currentSlide = $('.carousel-item.active');

	   	if (window.location.hash.substr(1) !== '') {
		    const hashSlide = '#'+window.location.hash.substr(1);
		    let $targetCaption;

		    if ($currentSlide.data('hash') !== hashSlide) {
		    	$currentSlide.removeClass('active');
		    }

		    $carouselItems.each(function() {
		    	const $this = $(this);

		    	if ($this.data('hash') === hashSlide) {
		    		$targetCaption = $this.data('slide-to');

		    		$this.addClass('active');
		    	}
		    });
		    
		    const $captions = $('.carousel-caption');

			$captions.each(function() {			    		
			    const $this = $(this);

			    if ($this.hasClass('active')) {
			    	$this.removeClass('active');
			    }

	    		if ($targetCaption === $this.data('caption-to')) {
	    			$(this).addClass('active');
	    		}
			});
	   	}

	    let $currentSlideNumber = $('.carousel-item.active').index() + 1,
	    	$carouselCountActive = $('.carousel-counter-active');

	    $carouselCountActive.text($currentSlideNumber);

	    $('.carousel-indicators').on('click', '.carousel-indicator-item', function() {
	    	ImageLoader.resizeBackgroundImages();
	    });

		$carousel.on('slide.bs.carousel', function () {
			ImageLoader.resizeBackgroundImages();
		});

	    $carousel.on('slid.bs.carousel', function () {
	    	const $caption = $('.carousel-caption'),
	    		  $activeSlide = $('.carousel-item.active').data('slide-to'),
	    	  	  $currentSlideNumber = $('.carousel-item.active').index() + 1;

	    	window.location.hash = $('.carousel-item.active').data('hash');

	    	$carouselCountActive.text($currentSlideNumber);

	    	$caption.each(function () {
	    		if ($(this).data('caption-to') === $activeSlide) {
	    			$('.carousel-caption.active').removeClass('active');
	    			$(this).addClass('active');
	    		}
	    	});
	    });
	}

	saveState(object, url) {
		window.history.pushState(object, '', url);
	}
}

export default {
	init () {
		new Carousel();
	}
}


// WEBPACK FOOTER //
// ./src/js/modules/carousel.js